import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { FollowBackModel, UnfollowTrackingModel } from '@/types/unFollow';
import { NoDataView } from './NoDataView';
import { useRouter } from 'next/navigation';

const ResultsArea = ({
  unfollowBackList,
  unfollowTrackList,
}: {
  unfollowBackList?: FollowBackModel[];
  unfollowTrackList?: UnfollowTrackingModel[];
}) => {
  const router = useRouter();

  return (
    <div className="space-y-8">
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-4 p-3 bg-pink-100 text-pink-800 rounded-t-lg">Doesn't Follow Back</h2>
        {unfollowBackList && unfollowBackList?.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Target Account
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Download
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Until Date
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {unfollowBackList?.map((item, index) => {
                  const status = item?.status?.toLocaleLowerCase();

                  return (
                    <tr key={index}>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{item?.media_name}</div>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            status === 'completed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                          }`}
                        >
                          {item?.status}
                        </span>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          className={`text-indigo-600 hover:text-indigo-900 ${
                            status !== 'completed' && 'opacity-50 cursor-not-allowed'
                          }`}
                          disabled={status !== 'completed'}
                          onClick={() => item?.excel_url && window.open(item?.excel_url, '_blank')}
                        >
                          <DownloadIcon className="w-5 h-5" />
                        </button>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{item?.until_date ?? '--'}</div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="mt-4 text-right">
              <button
                className="bg-pink-500 hover:bg-pink-600 text-white font-bold py-2 px-4 rounded"
                onClick={() => {
                  router.push('/instagram-unfollowers-tracker');
                }}
              >
                Get More
              </button>
            </div>
          </div>
        ) : (
          <NoDataView btnVal={`Get More`} />
        )}
      </div>

      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-2xl font-semibold mb-4 p-3 bg-purple-100 text-purple-800 rounded-t-lg">
          Unfollow Tracking
        </h2>
        {unfollowTrackList && unfollowTrackList?.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Target Account
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Download
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Start Date
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    End Date
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {unfollowTrackList?.map((item, index) => {
                  const status = item?.status?.toLocaleLowerCase();
                  return (
                    <tr key={index}>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{item?.media_name}</div>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            status === 'completed'
                              ? 'bg-green-100 text-green-800'
                              : status === 'tunning'
                                ? 'bg-yellow-100 text-yellow-800'
                                : 'bg-blue-100 text-blue-800'
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          className={`text-indigo-600 hover:text-indigo-900 ${
                            status !== 'completed' && 'opacity-50 cursor-not-allowed'
                          }`}
                          disabled={status !== 'completed'}
                          onClick={() => item?.excel_url && window.open(item?.excel_url, '_blank')}
                        >
                          <DownloadIcon className="w-5 h-5" />
                        </button>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{item?.start_date}</div>
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{item?.end_date}</div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="mt-4 text-right">
              <button
                className="bg-pink-500 hover:bg-pink-600 text-white font-bold py-2 px-4 rounded"
                onClick={() => {
                  router.push('/instagram-unfollowers-tracker');
                }}
              >
                ADD New Target
              </button>
            </div>
          </div>
        ) : (
          <NoDataView btnVal={`ADD New Target`} />
        )}
      </div>
    </div>
  );
};

export default ResultsArea;
